import React from "react";
import { Box, MenuItem, Separator } from "@showitinc/showit-wc";
import ContextMenuWrapper from "./ContextMenuWrapper";
import uiPrefix from "../../utils/UiPrefixUtils";
import AppConstants from "../../constants/AppConstants";

import UIActions from "../../actions/UIActions";
import DocumentStore from "../../document/DocumentStore";
import { COMMANDS } from "../../document/commands";
import UserActions from "../../actions/UserActions";
import styles from "./SitePanelCanvasSetContextMenu.module.css";
import UserEventConstants from "@/constants/UserEventConstants";

const { 
  CONTEXT_ITEM_BUTTON, 
  ITEM_TYPE_CANVAS_SET, 
  MODAL_ACTION_CONFIRM, 
} = AppConstants;
const { EVENT_CANVAS_SET_DELETE } = UserEventConstants;

/**
 * Renders a dropdown menu for a canvas set in the pages panel
 * @component
 * @param {Object} props -
 * @param {Object} props.canvasSet - The canvas set object
 * @param {boolean} props.active - Indicates if the set is selected
 * @returns {React.ReactElement}
 */

const SitePanelCanvasSetContextMenu = ({ canvasSet, active }) => {
  const id = canvasSet.get("id");
  const name = canvasSet.get("name");
  const slug = canvasSet.get("slug");
  const isDefault = canvasSet.get("default") === 1;

  const _makeDefault = () => {
    DocumentStore.dispatch({ type: COMMANDS.MAKE_CANVAS_SET_DEFAULT, payload: { id } });
    UserActions.trackEvent({
      event: "canvas-set-default",
      meta: { canvasSet: slug },
    });
  };

  const _rename = () => {
    UIActions.toggleRenamePopup({
      title: "Canvas Set",
      itemType: ITEM_TYPE_CANVAS_SET,
      itemId: id,
      name,
      slug,
      showWarning: false,
    });
  };

  const _duplicate = () => {
    if (canvasSet) {
      DocumentStore.dispatch({ type: COMMANDS.DUPLICATE_CANVAS_SET, payload: { id } });
      UserActions.trackEvent({
        event: "canvas-set-duplicate",
        meta: { canvasSet: slug },
      });
    }
  };

  const _removeCanvasSetConfirmed = () => {
    if (id) {
      DocumentStore.dispatch({ type: COMMANDS.REMOVE_CANVAS_SET, payload: { id } });
      UserActions.trackEvent({ event: EVENT_CANVAS_SET_DELETE, meta: { canvasSet: slug } });
    }
  };

  const _removeCanvasSet = () => {
    UIActions.modalOpen(MODAL_ACTION_CONFIRM, {
      title: "Delete Canvas Set",
      question: "Are you sure you want to delete this canvas set?",
      message:
        "This removes this canvas set from your design and will affect all pages where it was used.",
      confirmBtn: "Delete Canvas Set",
      confirmAction: _removeCanvasSetConfirmed,
    });
  };

  return (
    <ContextMenuWrapper icon="menuMoreHoriz" active={active}>
      {!isDefault && (
        <MenuItem data-e2e={uiPrefix(`make-default-${CONTEXT_ITEM_BUTTON}`)} onClick={_makeDefault}>
          Make Default
        </MenuItem>
      )}
      <MenuItem data-e2e={uiPrefix(`rename-${CONTEXT_ITEM_BUTTON}`)} onClick={_rename}>
        Rename
      </MenuItem>
      <MenuItem data-e2e={uiPrefix(`duplicate-${CONTEXT_ITEM_BUTTON}`)} onClick={_duplicate}>
        Duplicate
      </MenuItem>
      <Separator variant="context-menu" />
      <MenuItem data-e2e={uiPrefix(`delete-${CONTEXT_ITEM_BUTTON}`)} onClick={_removeCanvasSet}>
        <Box className={styles.delete}>Delete</Box>
      </MenuItem>
    </ContextMenuWrapper>
  );
};

export default SitePanelCanvasSetContextMenu;
